<template>
  <div class="ew-auth">
    <div class="ew-auth__panel">
      <div class="ew-auth__card">
        <router-link to="/">
          <img class="ew-auth__logo" src="@/assets/images/logo-ew.png" alt="Logo Moovet">
        </router-link>

        <p class="ew-auth__hint">
          ¿Tienes cuenta en Moovet?
          <router-link to="/signin">Ingresa a tu cuenta aquí</router-link>
        </p>

        <form @submit.prevent="signup" novalidate>
          <div class="ew-form__row">
            <div class="ew-form__field">
              <label class="ew-label" for="su-first">Nombre *</label>
              <input
                id="su-first"
                type="text"
                class="ew-input ew-input--block"
                placeholder="Nombre"
                v-model="firstName"
                required
                @input="$v.firstName.$touch()"
                :class="{ 'is-invalid': $v.firstName.$error }"
              >
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="su-last">Apellido *</label>
              <input
                id="su-last"
                type="text"
                class="ew-input ew-input--block"
                placeholder="Apellido"
                v-model="lastName"
                required
                @input="$v.lastName.$touch()"
                :class="{ 'is-invalid': $v.lastName.$error }"
              >
            </div>
          </div>

          <div class="ew-form__field">
            <label class="ew-label" for="su-email">Correo electrónico *</label>
            <input
              id="su-email"
              type="email"
              class="ew-input ew-input--block"
              placeholder="correo@ejemplo.com"
              v-model="email"
              required
              @input="$v.email.$touch()"
              :class="{ 'is-invalid': $v.email.$error }"
            >
            <div class="ew-field-error" v-if="$v.email.$error">Debes introducir un correo electrónico válido</div>
          </div>

          <div class="ew-form__field">
            <label class="ew-label" for="su-phone">Teléfono *</label>
            <input
              id="su-phone"
              type="number"
              class="ew-input ew-input--block"
              placeholder="(442) 123 12 45"
              v-model="phone"
              required
              @input="$v.phone.$touch()"
              :class="{ 'is-invalid': $v.phone.$error }"
            >
            <div class="ew-field-error" v-if="$v.phone.$error">Debes introducir un número de teléfono válido</div>
          </div>

          <div class="ew-form__field">
            <label class="ew-label" for="su-password">Contraseña *</label>
            <input
              id="su-password"
              type="password"
              class="ew-input ew-input--block"
              placeholder="Mínimo 4 caracteres"
              v-model="password"
              required
              @input="$v.password.$touch()"
              :class="{ 'is-invalid': $v.password.$error }"
            >
            <div class="ew-field-error" v-if="$v.password.$error">
              La contraseña debe tener una longitud de entre {{ $v.password.$params.minLength.min }} y {{ $v.password.$params.maxLength.max }} caracteres
            </div>
          </div>

          <div class="ew-form__field">
            <label class="ew-label" for="su-password-confirm">Repetir contraseña *</label>
            <input
              id="su-password-confirm"
              type="password"
              class="ew-input ew-input--block"
              placeholder="Repite tu contraseña"
              v-model="passwordConfirm"
              required
              @input="$v.passwordConfirm.$touch()"
              :class="{ 'is-invalid': $v.passwordConfirm.$error }"
            >
            <div class="ew-field-error" v-if="$v.passwordConfirm.$error">Las contraseñas no coinciden</div>
          </div>

          <div class="ew-form__field">
            <label class="ew-label" for="su-website">Sitio web <small>(opcional)</small></label>
            <input
              id="su-website"
              type="text"
              class="ew-input ew-input--block"
              placeholder="https://www.enviosweb.mx/"
              v-model="website"
              @input="$v.website.$touch()"
              :class="{ 'is-invalid': $v.website.$error }"
            >
            <div class="ew-field-error" v-if="$v.website.$error">URL inválida</div>
          </div>

          <p class="ew-auth__hint">
            <router-link to="/signin">Ingresa a tu cuenta aquí</router-link>
          </p>

          <button type="submit" class="ew-btn-primary ew-auth__submit" :disabled="$v.$invalid">Crear cuenta</button>
        </form>
      </div>
    </div>

    <div class="ew-auth__brand">
      <span class="ew-auth__brand-icon"><ph-icon name="map-pin" /></span>
      <p class="ew-auth__brand-text">Cotiza, genera y rastrea tus envíos, todo en un solo lugar.</p>
    </div>

    <a class="ew-call" href="tel:3317547337" aria-label="Llámanos">
      <img src="@/assets/images/call-answer.png" alt="">
    </a>
  </div>
</template>

<script>
import axios from 'axios'
import commons from '../commons'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import VueConfirmDialog from 'vue-confirm-dialog'
import Vue from 'vue'
import PhIcon from './icons/PhIcon'
Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
import {
  required,
  minLength,
  maxLength,
  email,
  url,
  sameAs
} from 'vuelidate/lib/validators'

export default {
  name: 'SignUp',
  data () {
    return {
      firstName: '',
      lastName: '',
      password: '',
      passwordConfirm: '',
      website: '',
      email: '',
      phone: '',
      rol: 'user'
    }
  },
  methods: {
    addEventPixelFacebook(){
      fbq('track', 'CompleteRegistration')
    },
    signup () {
      axios
        .post(`${commons.apiURL}/api/v1/users`, {
          firstName: this.firstName,
          lastName: this.lastName,
          password: this.password,
          website: this.website,
          email: this.email,
          phone: this.phone,
          rol: 'user'
        })
        .then(response => {
          this.addEventPixelFacebook()
          this.$confirm({
            title: 'Activación de cuenta',
            message: 'Te enviamos un mensaje a tu correo electrónico, por favor ingresa a tu bandeja y activa tu cuenta',
            button: {
              yes: 'Sí'
            },
            callback: confirm => {
              if (confirm) {
                this.$router.push('/signin?newUser=true')
              }
              }
          })
          this.$router.push('/signin?newUser=true')
        })
        .catch(error => {
          console.error(error)
        })
    },
    ...mapActions(['quoting', 'newShipment', 'getAllShipments']),
    ...mapMutations(['setNewShipmentRequestBody'])
  },
  computed: {
    ...mapGetters(['newShipmentRequestBody'])
  },
  validations: {
    firstName: {
      required,
      maxLength: maxLength(35)
    },
    lastName: {
      required,
      maxLength: maxLength(35)
    },
    email: {
      required,
      email,
      maxLength: maxLength(35)
    },
    phone: {
      required,
      maxLength: maxLength(10)
    },
    password: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(12)
    },
    passwordConfirm: {
      sameAsPassword: sameAs('password')
    },
    website: {
      url
    }
  },
  created () {
    if (localStorage.getItem('ew-user-id')) {
      this.$router.push('/dashboard')
      console.log('you are logged in')
    }
  },
  components: {
    'ph-icon': PhIcon
  }
}
</script>

<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-auth { @include app-tokens; @include ew-auth-shell; }
.ew-auth__panel { @include ew-auth-panel; }
.ew-auth__card { @include ew-auth-card; }
.ew-auth__logo { @include ew-auth-logo; }
.ew-auth__hint { @include ew-auth-hint; }
.ew-auth__brand { @include ew-auth-brand; }
.ew-auth__brand-icon { @include ew-auth-brand-icon; }
.ew-auth__brand-text { @include ew-auth-brand-text; }

.ew-form__row { display: flex; flex-wrap: wrap; gap: 1rem; > .ew-form__field { flex: 1 1 160px; min-width: 0; } }
.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; margin-bottom: 1.25rem; }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input { @include ew-input; }
.ew-input--block { width: 100%; }
.ew-field-error { @include ew-field-error; }

.ew-btn-primary { @include ew-btn-primary; }
.ew-auth__submit { width: 100%; height: 3rem; margin-top: 0.5rem; }

.ew-call {
  position: fixed;
  bottom: 1.75rem;
  left: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.75rem;
  height: 3.75rem;
  border-radius: 50%;
  background: var(--app-accent-button);
  box-shadow: 0 4px 10px rgba(7, 50, 88, 0.25);

  img { width: 1.5rem; height: auto; }

  &:hover { background: var(--app-accent-button-hover); }
  &:focus-visible { outline: 3px solid var(--app-accent); outline-offset: 2px; }
}

@media (max-width: 400px) {
  .ew-call { width: 3rem; height: 3rem; bottom: 1.2rem; left: 1.2rem; }
  .ew-call img { width: 1.25rem; }
}
</style>



// WEBPACK FOOTER //
// src/components/SignUp.vue